export enum SeriLogEnum {
    Information = 0,
    Warning = 1,
    Error = 2,
    Debug = 3,
    Verbose = 4,
    Fatal = 5
}